/**
 * Opens the size chart in a popup (native <dialog>) instead of leaving the product page.
 * The "Size chart" link keeps its real href, so it still works if this script doesn't run.
 */
if (!window.__sizeGuideDialogReady) {
  window.__sizeGuideDialogReady = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const opener = target.closest('[data-size-guide-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-size-guide-open'));
      if (dialog instanceof HTMLDialogElement && typeof dialog.showModal === 'function') {
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      }
      return;
    }

    const dialog = target.closest('dialog.size-guide-dialog');
    if (!dialog) return;

    // Close button, or a click on the dimmed backdrop (outside the dialog box)
    if (target.closest('[data-size-guide-close]')) {
      dialog.close();
      return;
    }
    if (target === dialog) {
      const box = dialog.getBoundingClientRect();
      const outside =
        event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
      if (outside) dialog.close();
    }
  });
}
